// Omnix/client/ui/ContactOverviewPanel.js
import { ComponentBase } from "../core/ComponentBase.js";
import { createAvatarElement } from "../../helpers/avatarHelper.js";

export class ContactOverviewPanel extends ComponentBase {
    static styles = `
        .contact-overview-panel {
            /* Panel container styles */
        }
        .contact-overview-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-bottom: 1.5rem;
        }
        .contact-overview-details {
            font-size: 0.9rem;
            color: var(--bs-secondary-color);
        }
        .contact-overview-details strong {
            color: var(--bs-body-color);
        }
        .recent-activity-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .activity-item {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 0.6rem 0;
            border-top: 1px solid var(--bs-border-color-translucent);
            font-size: 0.85rem;
        }
        .activity-icon {
            font-size: 1.2rem;
            color: var(--bs-secondary-color);
        }
        .activity-details {
            flex-grow: 1;
            overflow: hidden;
        }
        .activity-title {
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .activity-timestamp {
            font-size: 0.75rem;
            color: var(--bs-tertiary-color);
        }
    `;

    constructor(config) {
        super(config);
        this.contactId = null;
        this.overviewData = null;
        this.applyStyles();
    }

    async setContact(contactId) {
        if (this.contactId !== contactId) {
            this.contactId = contactId;
            await this.loadOverview();
        }
    }

    async loadOverview() {
        if (!this.contactId) {
            this.overviewData = null;
            this.render();
            return;
        }
        try {
            this.overviewData = await this.appClient.rpcClient.call('UnifiedInboxRpc.getContactOverview', {
                contactId: this.contactId
            });
            this.render();
        } catch (error) {
            this.log.error("Failed to load contact overview:", error);
            this.container.innerHTML = `<p class="text-danger">${this.t('Could not load contact details.')}</p>`;
        }
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'contact-overview-panel';
        }
        this.container.innerHTML = '';

        if (!this.overviewData) {
            this.container.innerHTML = `<div class="text-center p-3"><div class="spinner-border spinner-border-sm"></div></div>`;
            return this.container;
        }

        const { contact, activity } = this.overviewData;
        const avatar = createAvatarElement({ displayName: contact.firstName, avatarUrl: contact.avatarUrl, sizeClass: 'large' });

        const header = document.createElement('div');
        header.className = 'contact-overview-header';
        header.innerHTML = `
            ${avatar.outerHTML}
            <h5 class="mt-2 mb-1">${contact.firstName} ${contact.lastName || ''}</h5>
            <div class="contact-overview-details">
                <div><strong>Email:</strong> ${contact.email || 'N/A'}</div>
                <div><strong>Company:</strong> ${contact.company || 'N/A'}</div>
            </div>
            <a href="/user/contacts?contactId=${contact._id}" class="btn btn-sm btn-outline-secondary mt-3">${this.t('View Full Profile')}</a>
        `;
        this.container.appendChild(header);

        const activitySection = document.createElement('div');
        activitySection.innerHTML = `<h6 class="sidebar-section-title">${this.t('Recent Activity')}</h6>`;
        const list = document.createElement('ul');
        list.className = 'recent-activity-list';

        if (activity.length === 0) {
            list.innerHTML = `<li class="text-muted small text-center p-2">${this.t('No recent activity.')}</li>`;
        } else {
            activity.forEach(item => {
                const li = document.createElement('li');
                li.className = 'activity-item';
                // In the future, we'll differentiate between conversation and ticket icons
                li.innerHTML = `
                    <i class="bi bi-chat-dots activity-icon"></i>
                    <div class="activity-details">
                        <div class="activity-title">${item.channelDisplay}: ${item.lastInteractionSnippet}</div>
                        <div class="activity-timestamp">${new Date(item.lastInteractionTimestamp).toLocaleString()}</div>
                    </div>
                `;
                list.appendChild(li);
            });
        }
        activitySection.appendChild(list);
        this.container.appendChild(activitySection);

        return this.container;
    }
}